import { ExclamationCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Input,
  message,
  Modal,
  Row,
  Table,
  Spin,
} from "antd";
import moment from "moment";
import { Component } from "react";
import "../Common.global.css";
const { confirm } = Modal;

const flexColumnOverflow = {
  display: "flex",
  flex: "auto",
  flexDirection: "column",
  overflowY: "scroll",
};
const flexColumn = {
  display: "flex",
  flex: "auto",
  flexDirection: "column",
};
const columns = [
  {
    title: "Name",
    dataIndex: "display_name",
    align: "center",
    ellipsis: true,
  },
  {
    title: "Amount",
    dataIndex: "amount",
    align: "center",
    ellipsis: true,
  },
  {
    title: "Date Updated",
    dataIndex: "updated_at",
    align: "center",
    ellipsis: true,
    render: (updated_at) => {
      return <>{moment(updated_at).format("DD/MM/YYYY HH:mm")}</>;
    },
    sorter: (a, b) => moment(a.updated_at).unix() - moment(b.updated_at).unix(),
  },
  {
    title: "Date Created",
    dataIndex: "inserted_at",
    align: "center",
    ellipsis: true,
    render: (inserted_at) => {
      return <>{moment(inserted_at).format("DD/MM/YYYY HH:mm")}</>;
    },
    sorter: (a, b) =>
      moment(a.inserted_at).unix() - moment(b.inserted_at).unix(),
  },
];

export default class RateType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRowKeys: [],
      selectedRows: [],
      rateTypes: [],
      rateName: null,
      rateAmount: null,
      newRateTypeModalVisible: false,
      isLoading: false,
    };
  }

  componentDidMount() {
    this.setState({
      isInitialLoading: true,
    });
    return this.refreshList();
  }

  refreshList = () => {
    this.setState({ isLoading: true });
    return fetch(`/api/v1/rate/type/list`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        token: this.props.accessToken,
      },
    })
      .then((res) => {
        if (!res.ok) {
          return res
            .json()
            .catch(() => {
              // Couldn't parse the JSON
              throw new Error(res.statusText);
            })
            .then(({ error }) => {
              // Got valid JSON with error response, use it
              throw new Error(error || res.statusText);
            });
        }
        return res.json();
      })
      .then((data) => {
        const { rateTypes } = data;
        this.setState({
          rateTypes: rateTypes || [],
        });
      })
      .catch((err) => {
        message.error(
          err instanceof Error ? err.message : "Server cannot be reached"
        );
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  onDeleteClick = () => {
    const { selectedRowKeys } = this.state;
    const requestData = {
      id: selectedRowKeys[0],
    };
    const _this = this;
    confirm({
      title: "Please confirm",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure you would like to delete the selected rate type?",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        return fetch(`/api/v1/rate/type/delete`, {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            token: _this.props.accessToken,
          },
          body: JSON.stringify(requestData),
        })
          .then((res) => {
            if (!res.ok) {
              throw new Error(res.statusText);
            }
            return res.json();
          })
          .then(() => {
            message.success("Delete Completed!");
            _this.setState({ selectedRowKeys: [] });
            _this.refreshList();
          })
          .catch(() => {
            message.error("Error deleting rate type!");
          });
      },
    });
  };

  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.setState({ selectedRowKeys, selectedRows });
  };

  onCreateRateTypeCancel = () => {
    this.setState({
      newRateTypeModalVisible: false,
      rateType: null,
    });
  };

  onCreateRateTypeOk = () => {
    const { rateAmount, rateName } = this.state;
    return fetch(`/api/v1/rate/type/new`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        token: this.props.accessToken,
      },
      body: JSON.stringify({
        rateAmount,
        rateName,
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
      })
      .then(() => {
        this.setState({
          newRateTypeModalVisible: false,
          rateType: null,
          selectedRows: [],
          selectedRowKeys: [],
        });
        this.refreshList();
        return message.success("Rate Type Created Successfully!");
      })
      .catch(() => {
        message.error("Error creating rate type!");
      });
  };

  onAddClick = () => {
    this.setState({
      newRateTypeModalVisible: true,
      rateAmount: null,
      rateName: null,
    });
  };

  render() {
    const {
      selectedRowKeys,
      rateTypes,
      newRateTypeModalVisible,
      selectedRows,
      isLoading,
      rateName,
      rateAmount,
    } = this.state;
    const rowSelection = {
      type: "radio",
      selectedRowKeys,
      onChange: this.onSelectChange,
    };

    return (
      <div className="site-feature-container">
        <div className="page-header-container">
          <div>
            <div className="page-header-main">Rate</div>
            <div className="page-header-sub">Type</div>
          </div>
        </div>
        <Card bodyStyle={flexColumn} style={flexColumnOverflow}>
          <Spin tip="Please Wait..." spinning={isLoading}>
            <Row>
              <div className="setting-section-search">
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Col
                    className="setting-detail-group"
                    style={{ padding: "0px" }}
                  >
                    {/* <Button
                      key="Add"
                      className="setting-section-search-btn"
                      type="primary"
                      onClick={this.onAddClick}
                    >
                      Add
                    </Button>
                    <Button
                      key="Delete"
                      className="setting-section-search-btn"
                      danger
                      onClick={this.onDeleteClick}
                      disabled={
                        selectedRowKeys.length === 0 ||
                        (selectedRows &&
                          (selectedRows[0].is_car ||
                            selectedRows[0].is_moto ||
                            selectedRows[0].is_lost))
                      }
                    >
                      Delete
                    </Button> */}
                  </Col>
                </Row>
              </div>
            </Row>
            <Row>
              <div className="table-section-header">Rate Types</div>
              <Table
                rowKey="id"
                style={{ overflow: "auto", width: "100%" }}
                rowSelection={rowSelection}
                columns={columns}
                dataSource={rateTypes}
                size="small"
                scroll={{ x: 800 }}
              />
            </Row>
          </Spin>
        </Card>
        <Modal
          title="Add Rate Type"
          closable={false}
          visible={newRateTypeModalVisible}
          onOk={this.onCreateRateTypeOk}
          onCancel={this.onCreateRateTypeCancel}
          okButtonProps={{ disabled: !rateName || !rateAmount || isLoading }}
          cancelButtonProps={{ disabled: isLoading }}
        >
          <Row>
            <Col span={24} className="visitor-detail-group">
              <Input.Group
                compact
                className="group-compact-select-wrapper"
                style={{ marginBottom: "10px" }}
              >
                <span className="ant-input-group-addon group-addon-label">
                  Name <span style={{ color: "red" }}>*</span>
                </span>
                <Input
                  name="rateName"
                  value={rateName}
                  onChange={(e) => {
                    const { name, value } = e.target;
                    this.setState({
                      [name]: value,
                    });
                  }}
                />
              </Input.Group>
              <Input.Group
                compact
                className="group-compact-select-wrapper"
                style={{ marginBottom: "10px" }}
              >
                <span className="ant-input-group-addon group-addon-label">
                  Amount <span style={{ color: "red" }}>*</span>
                </span>
                <Input
                  type="number"
                  name="rateAmount"
                  value={rateAmount}
                  onChange={(e) => {
                    const { name, value } = e.target;
                    this.setState({
                      [name]: value,
                    });
                  }}
                />
              </Input.Group>
            </Col>
          </Row>
        </Modal>
      </div>
    );
  }
}
